/* ================================================================
   K-NIN CONCEPT STORE — Header JavaScript
   assets/knin-header.js

   Comportements :
   - Header sticky avec ombre au scroll
   - Drawer menu mobile (ouverture/fermeture/overlay/escape)
   - Mise en évidence du lien actif (header + bottom bar)
   ================================================================ */

(function () {
  'use strict';

  /* ── Sélecteurs ─────────────────────────────────────────────── */
  var header      = document.getElementById('knin-header');
  var burger      = document.getElementById('knin-burger');
  var drawer      = document.getElementById('knin-drawer');
  var overlay     = document.getElementById('knin-overlay');
  var closeBtn    = document.getElementById('knin-drawer-close');

  if (!header) return;

  /* ── Header sticky au scroll ─────────────────────────────────── */
  var SCROLL_THRESHOLD = 10;

  function onScroll() {
    if (window.scrollY > SCROLL_THRESHOLD) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // état initial

  /* ── Drawer mobile ───────────────────────────────────────────── */
  var isDrawerOpen = false;

  function openDrawer() {
    if (!drawer || !burger || isDrawerOpen) return;
    isDrawerOpen = true;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    burger.classList.add('is-open');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    // Retour de focus accessible
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
  }

  function closeDrawer() {
    if (!drawer || !burger || !isDrawerOpen) return;
    isDrawerOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    burger.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    burger.focus();
  }

  /* Toggle via bouton burger */
  if (burger) {
    burger.addEventListener('click', function () {
      isDrawerOpen ? closeDrawer() : openDrawer();
    });
  }

  /* Fermeture via bouton × */
  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }

  /* Fermeture via clic sur l'overlay */
  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  /* Fermeture via la touche Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isDrawerOpen) closeDrawer();
  });

  /* Fermeture automatique au clic sur un lien du drawer (hors déclencheur d'accordéon) */
  var drawerLinks = document.querySelectorAll('.knin-drawer__link:not(.knin-drawer__group-trigger), .knin-drawer__sublink');
  drawerLinks.forEach(function (link) {
    link.addEventListener('click', function () {
      closeDrawer();
    });
  });

  /* ── Trap focus dans le drawer (accessibilité) ───────────────── */
  if (drawer) {
    drawer.addEventListener('keydown', function (e) {
      if (!isDrawerOpen || e.key !== 'Tab') return;

      var focusables = drawer.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      var first = focusables[0];
      var last  = focusables[focusables.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  /* ── Recherche ───────────────────────────────────────────────── */
  var searchBtns    = document.querySelectorAll('.knin-search-btn');
  var searchOverlay = document.getElementById('knin-search-overlay');
  var searchClose   = document.getElementById('knin-search-close');
  var searchInput   = document.getElementById('knin-search-input');

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    searchBtns.forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
    if (searchInput) setTimeout(function () { searchInput.focus(); }, 50);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    searchBtns.forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
  }

  searchBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      searchOverlay && searchOverlay.classList.contains('is-open') ? closeSearch() : openSearch();
    });
  });

  if (searchClose) {
    searchClose.addEventListener('click', closeSearch);
  }

  var searchBackdrop = document.getElementById('knin-search-overlay-backdrop');
  if (searchBackdrop) {
    searchBackdrop.addEventListener('click', closeSearch);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('is-open')) {
      closeSearch();
    }
  });

  /* ── Méga-menu Boutique (desktop) + accordéon (drawer mobile) ───── */
  var dropTriggers = document.querySelectorAll('.knin-navdrop__trigger, .knin-drawer__group-trigger');

  dropTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      dropTriggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.knin-navdrop')) {
      document.querySelectorAll('.knin-navdrop__trigger').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      dropTriggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }
  });

  /* ── Compteur panier en temps réel ──────────────────────────── */
  function updateCartBadge(count) {
    document.querySelectorAll('.knin-cart-btn').forEach(function (btn) {
      var badge = btn.querySelector('.knin-cart-count');
      btn.setAttribute('aria-label', 'Panier — ' + count + ' article' + (count !== 1 ? 's' : ''));
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'knin-cart-count';
          badge.setAttribute('aria-hidden', 'true');
          btn.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function refreshCartBadge() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { updateCartBadge(cart.item_count); })
      .catch(function () {});
  }

  /* Événement natif du thème (assets/events.js → ThemeEvents.cartUpdate = 'cart:update'),
     déclenché immédiatement après chaque ajout/modif panier avec le panier déjà à jour
     dans event.detail.resource : on l'utilise directement, sans requête réseau, pour un
     rendu instantané. Fallback sur refreshCartBadge si le panier n'est pas fourni. */
  document.addEventListener('cart:update', function (e) {
    var detail = (e && e.detail) || {};
    var resource = detail.resource;
    if (resource && typeof resource.item_count === 'number') {
      updateCartBadge(resource.item_count);
    } else {
      refreshCartBadge();
    }
  });

  /* Filet de sécurité : intercepter les succès /cart/add.js via Fetch natif */
  (function () {
    var _fetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var urlStr = (typeof url === 'string') ? url : (url && url.url) ? url.url : '';
      return _fetch.apply(this, arguments).then(function (res) {
        if (urlStr && urlStr.indexOf('/cart/add') !== -1 && res.ok) {
          refreshCartBadge();
        }
        return res;
      });
    };
  })();

  /* ── Ruban d'annonce défilant en boucle (pixel-exact, sans saccade) ──── */
  var announceSlides = document.querySelector('.announcement-bar__slides');
  if (announceSlides) {
    var announceText = announceSlides.querySelector('.announcement-bar__text');
    if (announceText && announceText.innerHTML.trim() !== '') {
      var REPEAT = 14;
      var track = document.createElement('div');
      track.className = 'knin-marquee-track';

      /* Groupe 1 : on le construit d'abord pour mesurer sa largeur */
      var firstGroup = [];
      for (var i = 0; i < REPEAT; i++) {
        var item = document.createElement('span');
        item.className = 'knin-marquee-item';
        item.innerHTML = announceText.innerHTML;
        track.appendChild(item);
        firstGroup.push(item);
      }

      announceSlides.innerHTML = '';
      announceSlides.appendChild(track);
      announceSlides.classList.add('knin-marquee-slides');

      /* Double rAF : on attend que le navigateur ait vraiment rendu le DOM */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          /* Largeur exacte d'un groupe (en pixels entiers) */
          var groupW = 0;
          firstGroup.forEach(function (el) { groupW += el.getBoundingClientRect().width; });
          groupW = Math.round(groupW);

          /* Groupe 2 = copie du groupe 1 pour la boucle seamless */
          for (var j = 0; j < REPEAT; j++) {
            track.appendChild(firstGroup[j].cloneNode(true));
          }

          /* Largeur fixe : évite tout reflow pendant l'animation */
          track.style.width = (groupW * 2) + 'px';

          /* Keyframe avec valeur pixel précise → zéro arrondi parasite */
          var styleEl = document.getElementById('knin-marquee-kf') || document.createElement('style');
          styleEl.id = 'knin-marquee-kf';
          styleEl.textContent =
            '@keyframes knin-marquee{' +
            '0%{transform:translate3d(0,0,0)}' +
            '100%{transform:translate3d(-' + groupW + 'px,0,0)}' +
            '}';
          document.head.appendChild(styleEl);

          /* Lance l'animation */
          track.style.animation = 'knin-marquee 55s linear infinite';
        });
      });
    }
  }

  /* ── Liens actifs : header nav ───────────────────────────────── */
  var currentPath = window.location.pathname;

  function isLinkActive(href) {
    if (!href) return false;
    try {
      // Gestion des URLs absolues et relatives
      var url = new URL(href, window.location.origin);
      var path = url.pathname;
      if (path === '/') return currentPath === '/';
      return currentPath === path || currentPath.startsWith(path + '/');
    } catch (_) {
      return false;
    }
  }

  /* Nav desktop + drawer */
  var navLinks = document.querySelectorAll('.knin-nav-link, .knin-drawer__link');
  navLinks.forEach(function (link) {
    if (isLinkActive(link.getAttribute('href'))) {
      link.classList.add('is-active');
    }
  });

  /* ── Liens actifs : bottom bar mobile ────────────────────────── */
  var bottomItems = document.querySelectorAll('.knin-bottom-bar__item');
  bottomItems.forEach(function (item) {
    if (isLinkActive(item.getAttribute('href'))) {
      item.classList.add('is-active');
      // Renforce le trait SVG pour l'élément actif
      var svg = item.querySelector('svg');
      if (svg) svg.setAttribute('stroke-width', '2.5');
    }
  });

})();
